module.exports = __webpack_public_path__ + "static/img/icon_94_xiajia.986bffc4.png";